import {
    defineStore,
} from 'pinia'
import {
    useStorage,
} from '@vueuse/core'
import {
    useLogStore,
} from '~~/stores/log'

export const useAppStore = defineStore('app', {
    state: () => {
        return {
            isMenuOpen: useStorage('menu-open', true, localStorage),
            isLogOpen: useStorage('log-open', true, localStorage),
            isDarkMode: useStorage('dark-mode', true),
            menuWidth: useStorage('menu-width', 200, localStorage),
            logWidth: useStorage('log-width', 300, localStorage),
        }
    },

    actions: {
        toggleMenu() {
            const logStore = useLogStore()
            this.isMenuOpen = !this.isMenuOpen
            logStore.info('toggling menu', this.isMenuOpen)
        },

        toggleLog() {
            const logStore = useLogStore()
            this.isLogOpen = !this.isLogOpen
            logStore.info('toggling log', this.isLogOpen)
        },

        toggleMode() {
            const logStore = useLogStore()
            this.isDarkMode = !this.isDarkMode
            logStore.info('toggling dark mode', this.isDarkMode)
        },
    },
})
